import styled from 'styled-components';
import academyStyles from './academy-styles';

export default function AcademyIconSvgCollection(props) {
  const defaultWidth = 16;
  const defaultHeight = 16;

  const height = props.height || defaultHeight;
  const calculatedWidth = (defaultWidth / defaultHeight) * height;

  return (
    <AcademyIconWrapper width={calculatedWidth} height={height} role="none">
      <canvas width={calculatedWidth} height={height} />
      <svg width={calculatedWidth} height={height} viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.5">
          <g transform="translate(-146.000000, -1620.000000)">
            <g transform="translate(120.000000, 1202.000000)">
              <g transform="translate(24.000000, 416.000000)">
                <rect fill="#FFFFFF" opacity="0" x="0" y="0" width="20" height="20" />
                <path
                  d="M16,16 L7,16 L7,17 L17,17 L17,7 L16,7 L16,16 Z M15,5 L14,5 L14,14 L5,14 L5,15 L15,15 L15,5 Z M13,3 L3,3 L3,13 L13,13 L13,3 Z M4,16 L4,14 L2,14 L2,2 L14,2 L14,4 L16,4 L16,6 L18,6 L18,18 L6,18 L6,16 L4,16 Z"
                  fill={props.color || academyStyles.common.contentTypeIconColor}
                  fillRule="nonzero"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </AcademyIconWrapper>
  );
}

const AcademyIconWrapper = styled.div`
  display: inline-block;
  position: relative;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  canvas {
    visibility: hidden;
  }
  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
  }
`;
